import { defineMessages } from 'react-intl';

export default defineMessages({
	documentTitle: {
		defaultMessage: 'Customer Login - Help Center',
		description: 'Login page document title',
		id: 'cv.login.document.title',
	},
	header: {
		defaultMessage: 'Log in to {helpCenterName}',
		description: 'Page header',
		id: 'cv.login.header',
	},
	helpCenterLink: {
		defaultMessage: 'Go to { helpCenterName } home page',
		description: 'Text for link that redirects to the portals home page',
		id: 'cv.login.helpcenter.link',
	},
	description: {
		defaultMessage: 'Enter your email to log in or sign up',
		description: 'Description shown about the initial login screen',
		id: 'cv.login.description',
	},
	descriptionLogin: {
		defaultMessage: 'Log in to continue',
		description: 'Description shown after email check is customer login',
		id: 'cv.login.description.login',
	},
	useAtlassianAccountLogin: {
		defaultMessage: 'Use Atlassian account to log in',
		description: 'Description shown when login form is in atlassian SSO state',
		id: 'cv.login.use.atlassian.account.log.in',
	},
	useAtlassianAccountSignup: {
		defaultMessage: 'Use Atlassian account to sign up',
		description: 'Description shown when login form is in atlassian JIT state',
		id: 'cv.login.use.atlassian.account.sign.up',
	},
	backButton: {
		defaultMessage: 'Back',
		description: 'Button text for navigating back in the login screen',
		id: 'cv.login.back.button',
	},
	noLoginMethodWarningContent: {
		defaultMessage:
			'Access to the help center is unavailable. Try again later or contact your admin for assistance.',
		description: 'No available login method warning content',
		id: 'cv.login.no.login.method.warning.content',
	},
});
